import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";

function EditImpression() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = { width: "10em", whiteSpace: "nowrap" };
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token");
  const [impressionData, setImpressionData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   publipostage *******************************/
  const [publipostageData, setPublipostageData] = useState({ data: [] });
  const [selectedPublipostage, setSelectedPublipostage] = useState("");
  const handlePublipostageChange = (e) => {
    setSelectedPublipostage(e);
  };
  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPublipostageData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: publipostageData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  /************************* Nature investissement *******************************/
  const [natureInvestissementData, setNatureInvestissementData] = useState({
    data: [],
  });
  const [selectedNatureInvestissement, setSelectedNatureInvestissement] =
    useState("");
  const handleNatureInvestissementChange = (e) => {
    setSelectedNatureInvestissement(e);
  };
  const getNatureInvest = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/impressions/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setNatureInvestissementData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderNatureInvestissementOptions = () => {
    return [
      {
        options: natureInvestissementData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END  *******************************/
  /*************************   Produits  *******************************/
  const [produitsData, setproduitsData] = useState({ data: [] });
  const [selectedProduit, setSelectedProduit] = useState("");
  const handleProduitChange = (e) => {
    setSelectedProduit(e);
  };
  const getProduit = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/produits`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setproduitsData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderProduitOptions = () => {
    return [
      {
        options: produitsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END produits *******************************/
  /************************* investissements  *******************************/
  const [selectedInvestissements, setSelectedInvestissements] = useState("");
  const [investissementsData, setInvestissementsData] = useState({ data: [] });
  const handleInvestissementChange = (e) => {
    setSelectedInvestissements(e);
  };

  const getInvestissements = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/investissements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((investissements) => {
          setInvestissementsData(investissements);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestissementOptions = () => {
    return [
      {
        options: investissementsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Réservation   *******************************/
  const [selectedReservation, setSelectedReservation] = useState("");
  const [reservationData, setReservationData] = useState({ data: [] });
  const handleReservationChange = (e) => {
    setSelectedReservation(e);
  };
  const getReservation = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/impressions/reservations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((reservation) => {
          setReservationData(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderReservationOptions = () => {
    return [
      {
        options: reservationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Reservation *******************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/impressions/show_fields?publipostage_id=${
          selectedModele?.value || ""
        }&produit_id=${selectedProduit?.value || ""}&pme_id=${
          selectedPme?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   Modele *******************************/
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };

  /*************************   END Modele  *******************************/
  const [selectedChamps1, setSelectedChamps1] = useState("");
  const [selectedChamps2, setSelectedChamps2] = useState("");
  const [selectedChamps3, setSelectedChamps3] = useState("");
  const [selectedChamps4, setSelectedChamps4] = useState("");
  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");
  function getFieldValue(champNumber) {
    switch (champNumber) {
      case 1:
        return selectedChamps1;
      case 2:
        return selectedChamps2;
      case 3:
        return selectedChamps3;
      case 4:
        return selectedChamps4;
      case 5:
        return selectedChamps5;
      case 6:
        return selectedChamps6;
      default:
        return null;
    }
  }

  function handleFieldChange(champNumber, value) {
    switch (champNumber) {
      case 1:
        setSelectedChamps1(value);
        break;
      case 2:
        setSelectedChamps2(value);
        break;
      case 3:
        setSelectedChamps3(value);
        break;
      case 4:
        setSelectedChamps4(value);
        break;
      case 5:
        setSelectedChamps5(value);
        break;
      case 6:
        setSelectedChamps6(value);
        break;
      default:
        break;
    }
  }
  const handleChamps1Change = (e) => {
    setSelectedChamps1(e.target.value);
  };

  const handleChamps2Change = (e) => {
    setSelectedChamps2(e.target.value);
  };

  const handleChamps3Change = (e) => {
    setSelectedChamps3(e.target.value);
  };

  const handleChamps4Change = (e) => {
    setSelectedChamps4(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };

  /*************************   Date d'engagement et limite *******************************/
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateLimite, setSelectedDateLimite] = useState("");

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedFichier(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  /************************* END Complément   *******************************/

  /******************************* Date de début *******************************************/
  const [selectedDateDeDebut, setSelectedDateDeDebut] = useState("");

  /******************************* END date de début *******************************************/
  /******************************* date de fin *******************************************/
  const [selectedDateDeFin, setSelectedDateDeFin] = useState("");
  /******************************* Valide *******************************************/
  const [selectedValide, setSelectedValide] = useState("");
  const handleValideChange = (e) => {
    setSelectedValide(e);
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* END Valide *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  /******************************* END Mode de règlement *******************************************/
  /******************************* IBAN *******************************************/
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  /******************************* END IBAN *******************************************/
  /******************************* BIC *******************************************/
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /******************************* END BIC *******************************************/
  /******************************* RUM *******************************************/
  const [selectedRum, setSelectedRum] = useState("");
  const handleRumChange = (e) => {
    setSelectedRum(e.target.value);
  };
  /******************************* END RUM *******************************************/

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    // if (
    //   selectedPartenaire === null &&
    //   selectedStatut === null &&
    //   selectedTaux === null &&
    //   selectedAnnee === null
    // ) {
    //   toast.error("Remplissez les champs obligatoires");
    // } else if (selectedPartenaire === null && selectedStatut === null) {
    //   toast.error("Le statut et le partenaire ne peuvent pas être vide");
    // } else if (selectedTaux === null) {
    //   toast.error("Le taux ne peut pas être vide");
    // } else if (selectedAnnee === null) {
    //   toast.error("L'année ne peut pas être vide");
    // } else if (selectedPartenaire === null) {
    //   toast.error("Le partenaire ne peut pas être vide");
    // } else if (selectedStatut === null) {
    //   toast.error("Le statut ne peut pas être vide");
    // } else {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/impressions`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            impression: {
              id: id,
              date: selectedDate,
              publipostage_id: selectedModele?.value,
              date_de_debut: setSelectedDateDeDebut,
              date_de_fin: selectedDateDeFin,
              champ_1: selectedChamps1,
              champ_2: selectedChamps2,
              champ_3: selectedChamps3,
              champ_4: selectedChamps4,
              champ_5: selectedChamps5,
              champ_6: selectedChamps6,
              valide: selectedValide,
              fichier: selectedFichier,
              natures_investissement_id: selectedNatureInvestissement?.value,
              pme_id: selectedPme?.value,
              investissement_id: selectedInvestissements?.value,
              produit_id: selectedProduit?.value,
              reservation_id: selectedReservation?.value,
            },
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.reservation_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors =
            responseData?.contact_validation ||
            responseData?.investisseur_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
    // }
  };
  /******************************* END Validation *******************************************/

  useEffect(() => {
    if (!loading) {
      getPublipostage();
      getNatureInvest();
      getPme();
      getProduit();
      getReservation();
      getInvestissements();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [loading, selectedModele, selectedProduit, selectedPme]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Impression | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails impression
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/impressions/`}
                          style={{
                            color: "#3c88c8",
                            textDecoration: "underline !important",
                          }}
                        >
                          Impressions
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          impressionData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-info"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Caractéristiques
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Modèle :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="mb-2 col-md-8">
                                        <Select
                                          defaultValue={selectedModele}
                                          onChange={handleModeleChange}
                                          options={renderPublipostageOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                        {selectedModele === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Modèle ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Date :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="mb-2 col-md-8">
                                        <InputMask
                                          mask="99/99/9999"
                                          value={selectedDate}
                                          className="form-control input-color"
                                          onChange={(e) =>
                                            setSelectedDate(e.target.value)
                                          }
                                        />
                                        {selectedDate === "" && (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Date ne peut pas être vide
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>

                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Impression
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Valide:
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="mb-2 col-md-8">
                                        <Switch
                                          uncheckedIcon={<Offsymbol />}
                                          checkedIcon={<OnSymbol />}
                                          onColor="#3C88c8"
                                          onChange={() => {
                                            setSelectedValide(!selectedValide);
                                          }}
                                          checked={
                                            selectedValide == 1 ? true : false
                                          }
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "11em",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Fichier:
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="mb-2 col-md-8">
                                        {selectedFichier != null &&
                                          selectedFichier != "" && (
                                            <a href={selectedFichier}>Voir</a>
                                          )}
                                        <input
                                          className="form-control form-control-sm"
                                          type="file"
                                          required
                                          onChange={handleFichierChange}
                                        />
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Col>
                                  <Row>
                                    <Card className="mb-4">
                                      <CardTitle tag="h5">Filtres</CardTitle>
                                      <CardBody>
                                        <Row className="mb-3">
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  PME :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedPme}
                                                onChange={handlePmeChange}
                                                options={renderPmeOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>

                                          {showField?.displayed_fields?.includes(
                                            "investissement_id"
                                          ) && (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    Investissement :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <Select
                                                  defaultValue={
                                                    selectedInvestissements
                                                  }
                                                  onChange={
                                                    handleInvestissementChange
                                                  }
                                                  options={renderInvestissementOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          )}
                                          {showField?.displayed_fields?.includes(
                                            "reservation_id"
                                          ) && (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    Réservation :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <Select
                                                  defaultValue={
                                                    selectedReservation
                                                  }
                                                  onChange={
                                                    handleReservationChange
                                                  }
                                                  options={renderReservationOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          )}

                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Catégorie PME :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={
                                                  selectedNatureInvestissement
                                                }
                                                onChange={
                                                  handleNatureInvestissementChange
                                                }
                                                options={renderNatureInvestissementOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>

                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Produit :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedProduit}
                                                onChange={handleProduitChange}
                                                options={renderProduitOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>

                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Date de début :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              className="col-8"
                                              style={{ textAlign: "right" }}
                                            >
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateDeDebut}
                                                className="form-control input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateDeDebut(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>

                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Date de fin :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              className="col-8"
                                              style={{ textAlign: "right" }}
                                            >
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateDeFin}
                                                className="form-control input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateDeFin(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Row>
                                  <Col sm="12">
                                    <Row>
                                      <Col sm="12">
                                        <Row>
                                          <Col sm="12">
                                            <Card className="mb-4">
                                              <CardTitle tag="h5">
                                                Champs d'impression
                                              </CardTitle>
                                              <CardBody>
                                                {/* Champ 1 */}
                                                {showField?.displayed_fields?.includes(
                                                  "champ_1"
                                                ) && (
                                                  <Row className="mb-3">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          Champ 1:
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      <input
                                                        className="form-control"
                                                        defaultValue={
                                                          selectedChamps1
                                                        }
                                                        required
                                                        onChange={
                                                          handleChamps1Change
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                )}
                                                {/* Champ 2 */}
                                                {showField?.displayed_fields?.includes(
                                                  "champ_2"
                                                ) && (
                                                  <Row className="mb-3">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          Champ 2:
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      <input
                                                        className="form-control"
                                                        defaultValue={
                                                          selectedChamps2
                                                        }
                                                        required
                                                        onChange={
                                                          handleChamps2Change
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                )}
                                                {/* Champ 3 */}
                                                {showField?.displayed_fields?.includes(
                                                  "champ_3"
                                                ) && (
                                                  <Row className="mb-3">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          Champ 3:
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      <input
                                                        className="form-control"
                                                        defaultValue={
                                                          selectedChamps3
                                                        }
                                                        required
                                                        onChange={
                                                          handleChamps3Change
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                )}
                                                {/* Champ 4 */}
                                                {showField?.displayed_fields?.includes(
                                                  "champ_4"
                                                ) && (
                                                  <Row className="mb-3">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          Champ 4:
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      <input
                                                        className="form-control"
                                                        defaultValue={
                                                          selectedChamps4
                                                        }
                                                        required
                                                        onChange={
                                                          handleChamps4Change
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                )}
                                                {/* Champ 5 */}
                                                {showField?.displayed_fields?.includes(
                                                  "champ_5"
                                                ) && (
                                                  <Row className="mb-3">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          Champ 5:
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      <input
                                                        className="form-control"
                                                        defaultValue={
                                                          selectedChamps5
                                                        }
                                                        required
                                                        onChange={
                                                          handleChamps5Change
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                )}
                                                {/* Champ 6 */}
                                                {showField?.displayed_fields?.includes(
                                                  "champ_6"
                                                ) && (
                                                  <Row className="mb-3">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={4}
                                                      style={colStyle}
                                                    >
                                                      <i
                                                        style={{
                                                          color: "#9d9c9c",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            display:
                                                              "inline-block",
                                                            width: "11em",
                                                            paddingTop: "10px",
                                                          }}
                                                        >
                                                          Champ 6:
                                                        </span>
                                                      </i>
                                                    </Col>
                                                    <Col className="mb-2 col-md-8">
                                                      <input
                                                        className="form-control"
                                                        defaultValue={
                                                          selectedChamps6
                                                        }
                                                        required
                                                        onChange={
                                                          handleChamps6Change
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                )}
                                              </CardBody>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditImpression;
